// ==============================|| OVERRIDES - DATA GRID ||============================== //

export default function DataGrid(theme) {
    return {
        MuiDataGrid: {
            styleOverrides: {
                cell: {
                    borderBottom: `2px solid ${theme.palette.primary['lighter']}`,
                },
                columnHeaders: {
                    background: '#fff',
                    fontSize: '14px',
                    fontWeight: 400,
                    lineHeight: '22px',
                    columnHeaderTitle: {
                        fontSize: '14px',
                        fontWeight: 400,
                        lineHeight: '22px',
                    }
                },
                root: {
                    '& .MuiDataGrid-columnHeaderTitle':
                        {
                            fontSize: '14px',
                            fontWeight: 400,
                            lineHeight: '22px',
                        },
                    '& .MuiDataGrid-footerContainer': {
                        height: '40px',
                        borderTop: '1px solid #E1E2E9'
                    },
                   /* '& .MuiSvgIcon-root': {
                        color: theme.palette.black[30]
                    },*/
                    '& .MuiDataGrid-booleanCell[data-value="false"]':{
                        color: theme.palette.black[30]
                    },
                    '& .MuiTablePagination-selectLabel': {
                        color: theme.palette.black[20],
                        alignSelf: 'stretch',
                        //marginLeft: 'auto',
                        marginLeft: 0,
                    },
        
                    '& .MuiSelect-select': {
                        display: 'flex',
                        alignItems: 'center',
                    },
                    '& .MuiTablePagination-displayedRows': {
                        color: '#666666',
                        fontSize: '14px',
                        fontWeight: 400,
                        lineHeight: '22px'
                    },


                },
            },
        },
    };
}

